<template>
  <v-container class="pg2-page" fluid style="max-width: 1100px;">
    <v-btn small class="mb-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon left>mdi-arrow-left-bold</v-icon> Regresar
    </v-btn>

    <!-- SECCIÓN: HERO -->
    <v-card class="pg2-hero pa-5 mb-5">
      <div class="d-flex align-center justify-space-between mb-1">
        <v-chip x-small :color="modoEdicion ? 'amber darken-2' : 'white'" :dark="modoEdicion" label>
          <v-icon left x-small>{{ modoEdicion ? 'mdi-pencil' : 'mdi-plus-circle' }}</v-icon>
          {{ modoEdicion ? 'Editando programa' : 'Nuevo programa' }}
        </v-chip>
        <span v-if="modoEdicion" class="text-caption" style="color:rgba(255,255,255,0.7)">ID: {{ programa.programa_id }}</span>
      </div>
      <div class="pg2-hero__title mt-4">{{ programa.nombre_compuesto || '—' }}</div>
      <div class="pg2-hero__meta">
        <div class="pg2-hero__meta-item">
          <div class="label">Sede</div>
          <div class="value">{{ sedeNombre }}</div>
        </div>
        <div class="pg2-hero__meta-item" v-if="$route.query.modalidad || modoEdicion">
          <div class="label">Tipo programa</div>
          <div class="value">{{ $route.query.modalidad || programa.modalidad }}</div>
        </div>
        <div class="pg2-hero__meta-item">
          <div class="label">Inicio de campana</div>
          <div class="value"> {{ programa.fecha_matricula }}</div>
        </div>
        <div class="pg2-hero__meta-item" v-if="universidadsel && universidadsel.id">
          <div class="label">Universidad convenio</div>
          <div class="value">({{ universidadsel.abreviatura }}) {{ universidadsel.nombre }}</div>
        </div> 
        <div class="pg2-hero__meta-item" v-if="universidadsel && universidadsel.id">
          <div class="label">Version</div>
          <div class="value">{{ programa.version }}</div>
        </div> 
        <div class="pg2-hero__meta-item" v-if="universidadsel && universidadsel.id">
          <div class="label">Grupo</div>
          <div class="value">{{ programa.grupo }}</div>
        </div> 
        <div class="pg2-hero__meta-item" v-if="universidadsel && universidadsel.id">
          <div class="label">Gestion</div>
          <div class="value">{{ programa.gestion }}</div>
        </div> 
        <div class="pg2-hero__meta-item" v-if="universidadsel && universidadsel.id">
          <div class="label">Modalidad</div>
          <div class="value">{{ modalidades.find(x=>x.value==programa.modalidad).text }}</div>
        </div> 
      </div>
    </v-card>

    <!-- SECCIÓN: FORMULARIO -->
    <v-card :loading="loading" class="pg2-section">
      <div class="pg2-section-title d-flex align-center" style="gap:8px;">
        <v-icon color="teal darken-2" small>mdi-form-select</v-icon>
        Datos del programa
      </div>
      <v-card-text>
        <div class="pg2-sub-label">General</div>
        <p> Las fechas de inicio y finalización del programa serán actualizadas de acuerdo con las fechas establecidas en las cartas de invitación dirigidas a los docentes. </p>
        <v-row dense>
          <!-- <v-col cols="12" sm="3" lg="2">
            <v-text-field v-model.trim="programa.fecha_matricula" type="date"
              label="* Fec. inicio comercializacion" dense outlined hide-details
              :readonly="modoEdicion" />
          </v-col> -->
          <!-- <v-col cols="12" sm="4" lg="3">
            <v-text-field v-model.trim="programa.fecha_inicio" type="date"
              label="* Fecha inicio del programa" dense outlined hide-details />
          </v-col> -->
          <!-- <v-col cols="12" sm="3" lg="2">
            <v-text-field v-model.trim="programa.fecha_fin" type="date"
              label="Fecha fin del programa" dense outlined hide-details />
          </v-col> -->
          <!-- <v-col cols="6" sm="3" lg="2">
            <v-text-field v-model.number="programa.gestion" type="number"
              label="* Gestión" dense outlined hide-details />
          </v-col> -->
          <!-- <v-col cols="6" sm="3" lg="2">
            <v-text-field v-model.number="programa.version" type="number"
              label="* Versión" dense outlined hide-details />
          </v-col> -->
          <!-- <v-col cols="6" sm="3" lg="2">
            <v-text-field v-model.number="programa.grupo" type="number"
              label="* Grupo" dense outlined hide-details />
          </v-col> -->
          <!-- <v-col cols="12" sm="3">
            <v-select v-model="programa.modalidad" :items="modalidades"
              label="* Modalidad" dense outlined hide-details />
          </v-col> -->
          <!-- <v-col cols="6" sm="3" xl="2">
            <v-text-field v-model.number="programa.nota_aprobacion" type="number"
              label="* Nota mínima" dense outlined hide-details />
          </v-col>  -->
        </v-row>

        <v-divider class="my-4" />

        <div class="pg2-sub-label">Personal y convenio</div>
        <v-row dense>
          <v-col cols="12" sm="4">
            <SeleccionarUsuario v-model="coordinadorsel.idusuario" label="Coordinador de marketing" :preselect-id="coordinadorId" :preselect-nombre="coordinadorNombre" />
          </v-col>
          <v-col cols="12" sm="4">
            <SeleccionarUsuario v-model="responsablesel.idusuario" label="Responsable academico" :preselect-id="responsableId" :preselect-nombre="responsableNombre" />
          </v-col>
          <v-col cols="12" sm="4" v-if="!universidadsel && !loadingProgUnivConvenio">
            <v-select v-model="universidadsel" :items="convenios" item-text="nombre"
              label="Universidad convenio" dense outlined hide-details return-object clearable />
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <div class="pg2-sub-label">Portada del programa</div>
        <v-row dense align="start">
          <v-col cols="12" sm="6">
            <v-file-input v-model="archivoPortada" label="Seleccionar imagen"
              accept="image/*" dense outlined hide-details
              prepend-icon="" prepend-inner-icon="mdi-image"
              @change="onPortadaChange" />
            <div class="d-flex align-center mt-2" style="gap:8px;">
              <v-btn color="primary" :loading="cargandoportada"
                :disabled="!archivoPortada" @click="subirPortada" small>
                <v-icon left small>mdi-cloud-upload</v-icon> Subir
              </v-btn>
              <v-chip v-if="programa.portada" small color="green" dark>
                <v-icon left small>mdi-check</v-icon>{{ programa.portada }}
              </v-chip>
            </div>
          </v-col>
          <v-col cols="12" sm="auto">
            <div v-if="portadaPreviewUrl" class="pg2-portada-preview">
              <img :src="portadaPreviewUrl" alt="Portada" />
              <div class="pg2-portada-label text-caption text--secondary mt-1 text-center">
                {{ archivoPortada ? 'Vista previa (sin subir)' : 'Portada actual' }}
              </div>
            </div>
            <div v-else class="pg2-portada-placeholder">
              <v-icon large color="grey lighten-2">mdi-image-off-outline</v-icon>
              <div class="text-caption grey--text">Sin portada</div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- SECCIÓN: MÓDULOS -->
    <v-card class="pg2-section">
      <div class="pg2-section-title d-flex align-center" style="gap:8px;">
        <v-icon color="teal darken-2" small>mdi-book-open-page-variant</v-icon>
        Módulos
        <v-chip x-small color="teal lighten-4" class="teal--text text--darken-3 ml-1">{{ programa.programa_modulo.length }}</v-chip>
        <v-spacer />
        <template v-if="puedeEditarModulos">
          <div class="d-flex align-center mr-3" style="gap: 6px;">
            <span class="text-caption text--secondary">Numeración desde:</span>
            <v-btn-toggle v-model="numeracionModulosDesde" mandatory dense color="teal darken-1">
              <v-btn x-small :value="0">0</v-btn>
              <v-btn x-small :value="1">1</v-btn>
            </v-btn-toggle>
          </div>
          <v-btn vv-if="puede_editar_mods_auto" small color="teal darken-1" dark depressed @click="agregarModulo">
            <v-icon left small>mdi-plus</v-icon> Agregar módulo
          </v-btn>
        </template>
      </div>
      <v-card-text class="pa-0">
        <v-progress-linear v-if="loadingModulos" indeterminate color="teal" />

        <v-simple-table dense class="pg2-modulos-table" v-if="programa.programa_modulo.length">
          <thead>
            <tr>
              <th style="width:52px"> <small>Numero</small> </th>
              <th v-if="puedeEditarModulos" style="width:28px"></th>
              <th>Módulo</th>
              <th v-if="puedeEditarModulos" style="width:200px">*Tipo calificación</th>
              <th v-if="puedeEditarModulos" style="width:140px">*Fecha inicio</th>
              <th v-if="puedeEditarModulos" style="width:140px">*Fecha fin</th>
              <th v-if="puedeEditarModulos" style="width:100px" class="text-right">Orden</th>
            </tr>
          </thead>
          <draggable
            tag="tbody"
            v-model="programa.programa_modulo"
            handle=".drag-handle"
            :disabled="!puedeEditarModulos || !puede_editar_mods_auto"
            :animation="150"
            ghost-class="pg2-row-ghost"
            @end="renumerarTrasArrastre"
          >
            <tr v-for="(m, i) in programa.programa_modulo" :key="m.programa_modulo_id || i"
              :class="puedeEditarModulos ? 'pg2-row-draggable' : ''">
              <td>
                <v-chip x-small class="pg2-num-chip" label>{{ m.numero }}</v-chip>
              </td>
              <td v-if="puedeEditarModulos" class="drag-handle px-1 text-center" style="cursor:grab;">
                <v-icon small color="grey lighten-1">mdi-drag-vertical</v-icon>
              </td>
              <!-- version que tal ves no se use, ya que puede_editar_mods_auto siempre sera false :) -->
              <td v-if="puede_editar_mods_auto">
                <span v-if="m.xauto" class="text-body-2">
                  {{ m.xmodulo ? m.xmodulo.nombre : '—' }}
                </span>
                <v-autocomplete v-else
                  v-model="m.xmodulo"
                  :items="m._resultados"
                  :loading="m._loadingSearch"
                  :search-input.sync="m._busqueda" 
                  @update:search-input="(v) => buscarModulo(m, v)"
                  @change="m.modulo_id = m.xmodulo ? m.xmodulo.id : null"
                  item-text="nombre"
                  return-object
                  dense outlined hide-details
                  label="Buscar módulo..."
                  no-data-text="Escribe para buscar (mín. 2 caracteres)"
                  style="max-width: 420px;"
                />
              </td>
              <td v-else> 
                <!-- aqui el primer modulo, es el cero se puede eliminar pero no se puede ver como un combobox -->
                <span v-if="m.xauto || m.numero==0 || (m.numero == 1 && !m.xauto)" class="text-body-2">
                  {{ m.xmodulo ? m.xmodulo.nombre : '—' }}
                </span>
                <v-autocomplete v-else
                  v-model="m.xmodulo"
                  :items="m._resultados"
                  :loading="m._loadingSearch"
                  :search-input.sync="m._busqueda" 
                  @update:search-input="(v) => buscarModulo(m, v)"
                  @change="m.modulo_id = m.xmodulo ? m.xmodulo.id : null"
                  item-text="nombre"
                  return-object
                  dense outlined hide-details
                  label="Buscar módulo..."
                  no-data-text="Escribe para buscar (mín. 2 caracteres)"
                  style="max-width: 420px;"
                />
              </td>
              <td v-if="puedeEditarModulos">
                <v-select v-model="m.tipo_calificacion" :readonly="!puede_editar_mods_auto" :items="tiposCalificacion"
                  dense outlined hide-details />
              </td>
              <td v-if="puedeEditarModulos">
                <v-text-field v-model="m.fecha_inicio" type="date"
                  dense outlined hide-details clearable style="min-width:130px;" />
              </td>
              <td v-if="puedeEditarModulos">
                <v-text-field v-model="m.fecha_fin" type="date"
                  dense outlined hide-details clearable style="min-width:130px;" />
              </td>
              <td v-if="puedeEditarModulos" class="text-right">
                <v-btn v-if="puede_editar_mods_auto" icon x-small :disabled="i === 0" @click="moverModulo(i, -1)">
                  <v-icon small>mdi-arrow-up</v-icon>
                </v-btn>
                <v-btn v-if="puede_editar_mods_auto" icon x-small :disabled="i === programa.programa_modulo.length - 1"
                  @click="moverModulo(i, 1)">
                  <v-icon small>mdi-arrow-down</v-icon>
                </v-btn>
                <v-btn v-if="!m.xauto" icon x-small color="red" @click="quitarModulo(i)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </draggable>
        </v-simple-table>

        <div v-else-if="!loadingModulos" class="text-center text--secondary py-6">
          <v-icon large color="teal lighten-3">mdi-book-open-outline</v-icon>
          <div class="mt-1">Sin módulos cargados</div>
        </div>
      </v-card-text>
    </v-card>

    <!-- SECCIÓN: PLANES DE PAGO -->
    <v-card class="pg2-section">
      <div class="pg2-section-title d-flex align-center" style="gap:8px;">
        <v-icon color="teal darken-2" small>mdi-cash-multiple</v-icon>
        Planes de pago
        <v-chip x-small color="teal lighten-4" class="teal--text text--darken-3 ml-1">{{ programa.planes.length }}</v-chip>
        <v-spacer />
        <v-btn v-if="puedeEditarEstadoPlan" small color="teal darken-1" dark depressed @click="abrirDialogoAgregarPlan">
          <v-icon left small>mdi-plus</v-icon> Agregar plan
        </v-btn>
      </div>
      <v-card-text class="pa-3">
        <div v-for="(plan, pi) in programa.planes" :key="pi" class="pg2-plan-block mb-4"
          :class="{ 'pg2-plan-block--inactivo': plan.estado === false }">
          <!-- Header del plan -->
          <div class="pg2-plan-block__header d-flex align-center px-3 py-2"
            :class="plan.estado === false ? 'pg2-plan-header-inactive' : (plan.xauto ? 'pg2-plan-header-auto' : 'pg2-plan-header-template')">
            <v-chip x-small label class="pg2-plan-chip mr-2">
              {{ plan.xauto ? 'auto' : 'template' }}
            </v-chip>
            <span class="pg2-plan-name text-body-2">{{ plan.nombre }}</span>
            <v-spacer />
            <div class="d-flex align-center" style="gap: 6px;">
              <template v-if="puedeEditarEstadoPlan">
                <v-switch
                  v-model="plan.estado"
                  :color="plan.estado ? 'teal darken-1' : 'grey'"
                  dense hide-details
                  class="mt-0 pt-0"
                  style="transform: scale(0.85);"
                />
                <span class="text-caption" :class="plan.estado ? 'teal--text text--darken-2' : 'grey--text'">
                  {{ plan.estado ? 'Activo' : 'Inactivo' }}
                </span>
              </template>
              <v-chip v-else x-small :color="plan.estado ? 'teal lighten-4' : 'grey lighten-2'"
                :class="plan.estado ? 'teal--text text--darken-3' : 'grey--text text--darken-1'" label>
                {{ plan.estado ? 'Activo' : 'Inactivo' }}
              </v-chip>
              <v-btn v-if="!plan.xauto && !plan.plan_cobro_programa_id" icon x-small color="red" @click="quitarPlan(pi)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </div>
          </div>
          <!-- Tabla de cobros -->
          <v-simple-table dense class="pg2-cobros-table">
            <thead>
              <tr>
                <th>Concepto</th>
                <th style="width:140px">Monto (Bs / $)</th>
                <th style="width:170px">Cuotas</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(c, ci) in plan.cobros" :key="ci">
                <td>
                  <span v-if="plan.xauto || plan.xfromtemplate || plan.plan_cobro_programa_id" class="text-body-2">{{ c.nombre_concepto }}</span>
                  <v-text-field v-else v-model="c.nombre_concepto" dense outlined
                    hide-details placeholder="Concepto" />
                </td>
                <td>
                  <span v-if="plan.xauto || plan.plan_cobro_programa_id" class="text-body-2">{{ c.monto }}</span>
                  <v-text-field v-else v-model.number="c.monto" type="number"
                    dense outlined hide-details min="0" />
                </td>
                <td>
                  <span v-if="plan.xauto || plan.plan_cobro_programa_id" class="text-body-2">{{ c.cuotas }}</span>
                  <div v-else class="d-flex align-center" style="gap: 4px;">
                    <v-text-field v-model.number="c.cuotas" type="number"
                      dense outlined hide-details min="1" :max="c.xmax_cuotas"
                      style="max-width: 90px;"
                      @change="capCuotas(c)" />
                    <span v-if="plan.xfromtemplate" class="text-caption text--secondary">/ {{ c.xmax_cuotas }} max.</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>

        <div v-if="!programa.planes.length" class="text-center text--secondary py-6">
          <v-icon large color="teal lighten-3">mdi-cash-remove</v-icon>
          <div class="mt-1">Sin planes de pago</div>
        </div>
      </v-card-text>
    </v-card>

    <!-- DIÁLOGO: AGREGAR PLAN -->
    <v-dialog v-model="dialogAgregarPlan" max-width="620" scrollable>
      <v-card>
        <v-card-title class="text-subtitle-1">
          Agregar plan de pago
          <v-spacer />
          <v-btn icon small @click="dialogAgregarPlan = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <div class="text-caption text--secondary mb-2">Selecciona un template o crea uno personalizado</div>
          <v-progress-linear v-if="loadingTemplates" indeterminate color="primary" class="mb-3" />
          <v-list dense>
            <v-list-item
              v-for="t in templatesPlanes" :key="t.id"
              @click="seleccionarTemplate(t)"
              :disabled="!!programa.planes.find(p => p.nombre === t.nombre)"
              class="rounded mb-1"
              style="border: 1px solid #e0e0e0;"
            >
              <v-list-item-icon class="mr-3">
                <v-icon color="primary">mdi-file-document-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-body-2">{{ t.nombre }}</v-list-item-title>
                <v-list-item-subtitle>{{ t.conceptos ? t.conceptos.length : 0 }} conceptos</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-chip x-small color="green lighten-5" class="green--text text--darken-3"
                  v-if="programa.planes.find(p => p.nombre === t.nombre)">
                  ya agregado
                </v-chip>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey" @click="dialogAgregarPlan = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SECCIÓN: SUCURSAL PARA FACTURA (solo edición, solo cargos 1/14/15) -->
    <SucursalFactura
      v-if="modoEdicion && programa.programa_id && programa.sede_id"
      :programa-id="programa.programa_id"
      :sede-id="programa.sede_id"
      :sucursal-id="programa.sucursal_id || null"
      :can-edit="puedeEditarEstadoPlan"
      @change="sucursalTexto = $event"
    />

    <!-- MENSAJE Y BOTÓN GUARDAR -->
    <v-alert v-if="msg" type="error" dense text class="mb-4 mx-1" border="left">{{ msg }}</v-alert>
    <v-alert v-if="msg_reg" type="success" dense text class="mb-4 mx-1" border="left">{{ msg_reg }}</v-alert>
    <div class="pg2-save-area">
      <v-btn color="teal darken-1" class="pg2-save-btn white--text" x-large :disabled="!show_btn_save" :loading="loading" @click="guardarcambios">
        <v-icon left>mdi-content-save</v-icon> Guardar programa
      </v-btn>
    </div>

    <ModalConfirmarGuardar ref="refConfirmarGuardar" />
  </v-container>
</template>

<script>
import gql from 'graphql-tag';
// import xaxios from '@/xaxios';
import { getheadersrest } from '@/components/Utils';
import ProgramaUniversidadService from '@/views/pagos/services/programa-universidad.service';
import { getModulosProgramaUniversidad } from '@/views/programa-viewrest-esam';
import ModalConfirmarGuardar from './ModalConfirmarGuardar.vue';
import SeleccionarUsuario from './SeleccionarUsuario.vue';
import SucursalFactura from './SucursalFactura.vue';
import draggable from 'vuedraggable';

export default {
  name: 'ProgramaViewrestEsam2',
  components: { ModalConfirmarGuardar, SeleccionarUsuario, SucursalFactura, draggable },

  data() {
    return {
      loading: false,
      loadingModulos: false,
      loadingProgUnivConvenio: false,
      show_btn_save: false,
      msg: '',
      msg_reg: '',
      cargandoportada: false,
      archivoPortada: null,
      portadaPreviewUrl: null,
      xposgradin: {},
      universidadsel: null,
      convenios: [],
      sedes: [],
      coordinadorId: null,
      coordinadorNombre: null,
      responsableId: null,
      responsableNombre: null,
      coordinadorsel: { idusuario: null },
      responsablesel: { idusuario: null },
      programa: {
        nombre_compuesto: '',
        posgrado_id: null,
        xcategoria_id: null,
        nota_aprobacion: 71,
        version: 1,
        grupo: 1,
        gestion: new Date().getFullYear(),
        sede_id: null,
        modalidad: null,
        portada: null,
        fecha_matricula: '',
        fecha_inicio: '',
        fecha_fin: '',
        programa_modulo: [],
        planes: [],
        coordinador: {},
        responsable: {},
      },
      xprogramaraw: {},
      sucursalTexto: null,
      numeracionModulosDesde: 1,
      dialogAgregarPlan: false,
      templatesPlanes: [],
      conceptosPago: [],
      loadingTemplates: false,
      modalidades: [
        { text: 'Presencial', value: 'P' },
        { text: 'Virtual', value: 'V' },
        { text: 'Semipresencial', value: 'S' },
      ],
      tiposCalificacion: ['Moodle', 'Sistema', 'Moodle y Sistema'],
      puede_editar_mods_auto: false,
    };
  },

  computed: {
    modoEdicion() {
      return !!this.$route.query.edit;
    },
    puedeEditarEstadoPlan() {
      const id = this.$store.state.CARGO?.id;
      return id === 1 || id === 14 || id === 15;
    },
    puedeEditarModulos() {
      const id = this.$store.state.CARGO?.id;
      return id === 5 || id === 6 || id === 7 || id === 1;
    },
    sedeNombre() {
      const s = this.sedes.find(x => x.id === this.programa.sede_id);
      return s ? s.nombre : '—';
    },
  },

  watch: {
    numeracionModulosDesde(nuevo) {
      this.programa.programa_modulo.forEach((m, i) => { m.numero = i + nuevo; });
    },
  },

  methods: {
    // ── Carga inicial ─────────────────────────────────────────────────
    async getSedes() {
      const qs = gql`query{ getSedes{ id, nombre, unidad_negocio } }`;
      this.sedes = await this.$apollo.query({ query: qs })
        .then(({ data }) => data.getSedes).catch(() => []);
    },

    async getConveniosUniversidades() {
      const sql = gql`query { getInstituciones(estado: true) { id nombre convenio abreviatura } }`;
      const { data } = await this.$apollo.query({ query: sql });
      this.convenios = data.getInstituciones.filter(x => x.convenio);
    },

    async cargarProgramaParaEditar(id) {
      this.loading = true;
      const res = await fetch(`${process.env.VUE_APP_API_REST}/esam/programa/id/${id}`, { headers: getheadersrest() })
        .then(r => r.json()).catch(() => null);
      this.loading = false;
      if (!res || !res.programa_id) {
        this.$dialog.alert({ title: 'Error', body: `No se pudo cargar el programa con ID ${id}` });
        return;
      }

      // Convierte DD/MM/YYYY o YYYY-MM-DD (o ISO) a YYYY-MM-DD para inputs date
      const parseDate = d => {
        if (!d) return '';
        const s = String(d);
        if (s.includes('/')) {
          const [day, mon, yr] = s.split('/');
          return `${yr}-${mon}-${day}`;
        }
        return s.slice(0, 10); // ISO o YYYY-MM-DD
      };
      const modalidadMap = { PRESENCIAL: 'P', VIRTUAL: 'V', SEMIPRESENCIAL: 'S' };

      // Guardar campos del servidor que se deben reenviar en el PUT
      this.xprogramaraw = {
        estado: res.estado || null,
        fecha_registro: res.fecha_registro || null,
        fase: res.fase ?? 0,
        cuotas: res.cuotas ?? 0,
        modulo_finalizado: res.modulo_finalizado ?? 0,
        monto_matricula: res.monto_matricula ?? 0,
        monto_colegiatura: res.monto_colegiatura ?? 0,
        monto_certificacion: res.monto_certificacion ?? 0,
        estado_programa: res.estado_programa || null,
        categoria_programa: res.categoria_programa || null,
        estado_programa_desde: res.estado_programa_desde || null,
        is_campania: res.is_campania ?? false,
      };

      this.programa.programa_id = res.programa_id;
      this.programa.nombre_compuesto = res.nombre_compuesto || '';
      this.programa.posgrado_id = res.posgrado_id || null;
      this.programa.xcategoria_id = res.categoria ? res.categoria.id : null;
      this.programa.sede_id = res.sede_id || null;
      this.programa.modalidad = modalidadMap[res.modalidad] || res.modalidad || null;
      this.programa.nota_aprobacion = res.nota_aprobacion ?? 71;
      this.programa.version = res.version ?? 1;
      this.programa.grupo = res.grupo ?? 1;
      this.programa.gestion = res.gestion ?? new Date().getFullYear();
      this.programa.fecha_matricula = parseDate(res.fecha_matricula);
      this.programa.fecha_inicio = parseDate(res.fecha_inicio);
      this.programa.fecha_fin = parseDate(res.fecha_fin);
      this.programa.portada = res.portada || null;
      this.portadaPreviewUrl = res.portada ? `${process.env.VUE_APP_URL_PORTADAS}${res.portada}` : null;
      this.programa.sucursal_id = res.sucursal_id || null;

      // Módulos ordenados por numero
      const modulos = (res.programa_modulo || []).slice().sort((a, b) => a.numero - b.numero);
      this.programa.programa_modulo = modulos.map(m => ({
        programa_modulo_id: m.programa_modulo_id,
        modulo_id: m.modulo_id,
        numero: m.numero,
        tipo_calificacion: m.tipo_calificacion || 'Moodle y Sistema',
        fecha_inicio: parseDate(m.fecha_inicio),
        fecha_fin: parseDate(m.fecha_fin),
        modulo_programa_universidad_id: m.modulo_programa_universidad_id,
        xauto: true,
        xmodulo: { id: m.modulo_id, nombre: m.nombre || '—' },
        _busqueda: '',
        _resultados: [],
        _loadingSearch: false,
        _timeout: null,
      }));

      // Planes
      this.programa.planes = (res.planes || []).map(p => ({
        plan_cobro_programa_id: p.plan_cobro_programa_id,
        tipo_plan_id: p.tipo_plan_id || null,
        tipo_lista_precio_id: p.tipo_lista_precio_id || null,
        fecha_registro: p.fecha_registro || null,
        nombre: p.nombre,
        aprobado: p.aprobado || false,
        estado: p.estado !== undefined ? p.estado : true,
        xauto: false,
        xfromtemplate: false,
        xfromlistaprecio: false,
        xedit: false,
        cobros: (p.cobros || []).map(c => ({
          concepto_pago_id: c.concepto_id || c.concepto_pago_id,
          concepto_id: c.concepto_id || c.concepto_pago_id,
          nombre_concepto: c.nombre || c.nombre_concepto || '',
          nombre: c.nombre || c.nombre_concepto || '',
          monto: c.monto ?? 0,
          cuotas: c.cuotas ?? 1,
          facturable: c.facturable !== undefined ? c.facturable : null,
          xmax_cuotas: c.xmax_cuotas || null,
          xedit: false,
        })),
      }));

      // Coordinador / responsable
      window.console.log('[edit] coordinador raw:', res.coordinador);
      window.console.log('[edit] responsable raw:', res.responsable);
      if (res.coordinador) {
        this.coordinadorId = res.coordinador.id || res.coordinador.coordinador_id || null;
        this.coordinadorNombre = res.coordinador.nombres_completos || res.coordinador.nombres || res.coordinador.nombre || null;
      }
      if (res.responsable) {
        this.responsableId = res.responsable.id || res.responsable.responsable_id || null;
        this.responsableNombre = res.responsable.nombres_completos || res.responsable.nombres || res.responsable.nombre || null;
      }

      // Universidad convenio — puede venir como objeto o como id numérico
      const univId = res.universidad_convenio?.id || res.universidad_id || null;
      if (univId) {
        const found = this.convenios.find(c => c.id == univId);
        this.universidadsel = found || res.universidad_convenio || null;
      }
    },

    async cargarListaPrecios(programaUniversidadId) {
      if (!programaUniversidadId) return;
      try {
        this.loadingProgUnivConvenio = true;
        const { data } = await ProgramaUniversidadService.findOne(programaUniversidadId);
        const tipos = data?.datos?.listasPreciosPorTipo || [];
        this.programa.planes = this._buildPlanes2(tipos).map(p => ({
          ...p,
          xauto: true,
          xfromlistaprecio: true,
          xedit: false,
        }));
        this.setearConvenio(data?.datos);
        this.loadingProgUnivConvenio = false;
      } catch (e) {
        window.console.error('Error al cargar lista de precios', e);
      }
    },

    setearConvenio(proguniv){
      if(!proguniv) return;
      this.universidadsel = this.convenios.find(x=>x.id == proguniv.sedeUniversidad.universidadId)
    },

    _buildPlanes2(listasPreciosPorTipo) {
      const planes = [];
      listasPreciosPorTipo.forEach(tipo => {
        tipo.modalidades.forEach(modalidad => {
          const nombre = `${tipo.tipoListaPrecio} - PLAN ${modalidad.modalidadPago.toUpperCase()}`;
          const esContado = nombre.toLowerCase().includes('contado');
          planes.push({
            tipoListaPrecioId: tipo.tipoListaPrecioId,
            tipoListaPrecio: tipo.tipoListaPrecio,
            tipo_lista_precio_id: tipo.tipoListaPrecioId,
            lista_tipo_precio: nombre,
            nombre,
            aprobado: false,
            estado: true,
            cobros: modalidad.conceptos.map(c => ({
              concepto_pago_id: c.conceptoPago.id,
              nombre_concepto: c.conceptoPago.nombre,
              monto: c.monto,
              cuotas: esContado ? c.numeroCuotas > 2? 2: c.numeroCuotas : c.numeroCuotas,
              xmax_cuotas: c.numeroCuotas,
              xedit: false,
            })),
          });
        });
      });
      return planes;
    },

    // ── Portada ───────────────────────────────────────────────────────
    onPortadaChange(file) {
      if (!file) {
        // Si se limpió el input, volver a mostrar la del servidor si existe
        this.portadaPreviewUrl = this.programa.portada
          ? `${process.env.VUE_APP_URL_PORTADAS}${this.programa.portada}`
          : null;
        return;
      }
      const reader = new FileReader();
      reader.onload = e => { this.portadaPreviewUrl = e.target.result; };
      reader.readAsDataURL(file);
    },

    async subirPortada() {
      if (!this.archivoPortada) return;
      this.cargandoportada = true;
      const formData = new FormData();
      formData.append('file', this.archivoPortada);
      formData.append('nombre', `portada-${Date.now()}.jpg`);
      const result = await fetch(`${process.env.VUE_APP_URL_WEBDATA}portada_upload.php`, {
        method: 'POST', body: formData,
      }).then(r => r.json()).catch(() => null);
      this.cargandoportada = false;
      if (result?.status) {
        this.programa.portada = result.newCertName;
        this.archivoPortada = null;
        this.portadaPreviewUrl = `${process.env.VUE_APP_URL_PORTADAS}${result.newCertName}`;
        this.$root.$notify.show('Portada subida correctamente', { color: 'green', x: 'right' });
      }
    },

    // ── Módulos ───────────────────────────────────────────────────────
    async cargarModulosUniversidad() {
      const id = this.$route.query.programa_universidad_id;
      if (!id) return;
      this.loadingModulos = true;
      await getModulosProgramaUniversidad(this, id, this.programa);
      // normalizar fechas a YYYY-MM-DD para el input type=date
      const toInputDate = v => v ? String(v).slice(0, 10) : '';
      this.programa.programa_modulo.forEach(m => {
        m.xauto = true;
        m.fecha_inicio = toInputDate(m.fecha_inicio);
        m.fecha_fin = toInputDate(m.fecha_fin); 
      });
      this.loadingModulos = false;

      this.agregar_mod_cero()
    },

    agregar_mod_cero(){
      this.agregarModulo();
      const ultimo = this.programa.programa_modulo[this.programa.programa_modulo.length-1]
      const nombre_cero = "Tecnologías De La Información Y Transformación Digital";
      this.buscarModulo(ultimo,nombre_cero,true)
    },

    agregarModulo() {
      const manuales = this.programa.programa_modulo.filter(m => !m.xauto).length;
      const maxNumero = this.programa.programa_modulo.length > 0
        ? Math.max(...this.programa.programa_modulo.map(m => m.numero))
        : this.numeracionModulosDesde - 1;
      this.programa.programa_modulo.push({
        modulo_id: null,
        programa_modulo_id: -1 * manuales - 1,
        numero: maxNumero + 1,
        tipo_calificacion: 'Moodle y Sistema',
        fecha_inicio: '',
        fecha_fin: '',
        xauto: false,
        xmodulo: null,
        _busqueda: '',
        _resultados: [],
        _loadingSearch: false,
        _timeout: null,
      });
    },

    renumerarTrasArrastre() {
      this.programa.programa_modulo.forEach((m, i) => { m.numero = i + this.numeracionModulosDesde; });
    },

    quitarModulo(index) {
      this.programa.programa_modulo.splice(index, 1);
      this.programa.programa_modulo.forEach((m, i) => { m.numero = i + this.numeracionModulosDesde; });
    },

    moverModulo(index, dir) {
      const lista = this.programa.programa_modulo;
      const otro = index + dir;
      if (otro < 0 || otro >= lista.length) return;
      const tmpNum = lista[index].numero;
      lista[index].numero = lista[otro].numero;
      lista[otro].numero = tmpNum;
      const item = lista.splice(index, 1)[0];
      lista.splice(otro, 0, item);
    },

    async buscarModulo(modulo, texto, fijar_mod_cero=false) {
      if (!texto || texto.length < 2) { modulo._resultados = []; return; }
      clearTimeout(modulo._timeout);
      modulo._timeout = setTimeout(async () => {
        modulo._loadingSearch = true;
        const sql = gql`query{ getModulos(cursor:1000000, nombre:"${texto}"){ id, nombre } }`;
        const r = await this.$apollo.query({ query: sql, fetchPolicy: 'network-only' })
          .then(({ data }) => data).catch(() => ({}));
        modulo._resultados = r.getModulos || [];
        modulo._loadingSearch = false;
        const modcero = r.getModulos[0];
        if(fijar_mod_cero && modcero){
          modulo.modulo_id = modcero.id
          modulo.xmodulo = modcero
          const tams = this.programa.programa_modulo.length-1
          this.moverModulo(tams,tams*-1)
          this.numeracionModulosDesde = 0
        }
      }, 400);
    },

    // ── Planes ────────────────────────────────────────────────────────
    async _cargarTemplates() {
      if (this.templatesPlanes.length) return;
      this.loadingTemplates = true;
      const unidad = this.$store.state.CARGO.sede.unidad_negocio;
      try {
        const [resTemplates, resConceptos] = await Promise.all([
          fetch(`${process.env.VUE_APP_API_REST}/api/v1/esam/templates/planpagos?unidadnegocio=${unidad}&activo=true`, { headers: getheadersrest() }).then(r => r.json()),
          fetch(`${process.env.VUE_APP_API_REST}/api/pagos/conceptos/buscar`, { method: 'POST', headers: getheadersrest(), body: JSON.stringify({ unidad_negocio_id: unidad }) }).then(r => r.json()),
        ]);
        this.templatesPlanes = resTemplates.data || [];
        this.conceptosPago = resConceptos || [];
      } catch (e) {
        window.console.error('Error al cargar templates', e);
      } finally {
        this.loadingTemplates = false;
      }
    },

    async abrirDialogoAgregarPlan() {
      this.dialogAgregarPlan = true;
      await this._cargarTemplates();
    },

    resolverTipoPlanId() {
      if (!this.templatesPlanes.length) return;

      const norm = str => String(str).toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      // Más específicos primero para evitar falsos positivos
      const keywords = ['c. credito', 'c. contado', 'cuatrimestral', 'modular', 'carrera', 'antiguo', 'anual', 'credito', 'contado', 'curso'];

      const PRIORITY_NAMES = ['plan a credito gestion 2026', 'plan contado gestion 2026'];
      const prioritarios = this.templatesPlanes.filter(t =>
        PRIORITY_NAMES.some(pn => norm(t.nombre).includes(pn))
      );

      this.programa.planes.forEach(plan => {
        if (plan.tipo_plan_id) return;

        const planNorm = norm(plan.nombre);
        const kw = keywords.find(k => planNorm.includes(norm(k)));
        if (!kw) return;

        const kwNorm = norm(kw);

        // 1. Buscar en prioritarios con tipo_plan_id
        let match = prioritarios.find(t => norm(t.nombre).includes(kwNorm) && t.tipo_plan_id);

        // 2. Si no, buscar en todos los templates
        if (!match) {
          match = this.templatesPlanes.find(t => norm(t.nombre).includes(kwNorm) && t.tipo_plan_id);
        }

        if (match) plan.tipo_plan_id = match.tipo_plan_id;
      });
    },

    seleccionarTemplate(template) {
      // const esCredito = /cr[eé]dito/i.test(template.nombre);
      this.programa.planes.push({
        tipo_plan_id: template.tipo_plan_id,
        nombre: template.nombre,
        aprobado: false,
        estado: true,
        xauto: false,
        xfromtemplate: true,
        xfromlistaprecio: false,
        xedit: false,
        cobros: (template.conceptos || []).map(x => {
          const concepto = this.conceptosPago.find(c => c.id === x.concepto_pago_id);
          return {
            concepto_pago_id: x.concepto_pago_id,
            nombre_concepto: concepto ? concepto.nombre : `Concepto ${x.concepto_pago_id}`,
            monto: 0,
            // cuotas: esCredito ? 2 : x.max_cuotas,
            cuotas: x.max_cuotas,
            xmax_cuotas: x.max_cuotas,
            xedit: false,
          };
        }),
      });
      this.dialogAgregarPlan = false;
    },

    quitarPlan(index) {
      this.programa.planes.splice(index, 1);
    },

    capCuotas(c) {
      const val = Number(c.cuotas);
      if (isNaN(val) || val < 1) { c.cuotas = 1; return; }
      if (c.xmax_cuotas != null && val > Number(c.xmax_cuotas)) {
        c.cuotas = Number(c.xmax_cuotas);
      }
    },

    // ── Guardar ───────────────────────────────────────────────────────
    async guardarcambios() {
      this.msg = '';
      this.msg_reg = '';

      if (!this.programa.sede_id) { this.msg = 'Seleccione la sede'; return; }
      if (!this.programa.modalidad) { this.msg = 'Seleccione la modalidad'; return; }
      if (!this.programa.fecha_matricula) { this.msg = 'Ingrese la fecha de inicio de matriculaciones'; return; }
      // if (!this.programa.fecha_inicio) { this.msg = 'Ingrese la fecha de inicio del programa'; return; }
      if (!this.universidadsel) { this.msg = 'Seleccione la institucion de convenio'; return; }
      if (!this.modoEdicion) {
        if (!this.$route.query.programa_universidad_id) { this.msg = 'Falta programa_universidad_id en los parámetros'; return; }
        if (!this.$route.query.modalidad) { this.msg = 'Falta modalidad en los parámetros'; return; }
      }

      const isdev = process.env.VUE_APP_GRAPHQL?.includes('apidev');
      if (!this.programa.portada && isdev) this.programa.portada = 'sinfotoentest.jpg';
      if (!this.programa.portada) { this.msg = 'Suba la portada del programa'; return; }

      // Validar que todos los módulos tengan fechas
      // const moduloSinFecha = this.programa.programa_modulo.find(m => !m.fecha_inicio || !m.fecha_fin);
      // if (moduloSinFecha) {
      //   this.msg = `El módulo #${moduloSinFecha.numero} "${moduloSinFecha.xmodulo?.nombre || ''}" no tiene fecha de inicio o fin. Complete las fechas de todos los módulos antes de guardar.`;
      //   return;
      // }

      // Resolver tipo_plan_id en planes que no lo tengan
      await this._cargarTemplates();
      this.resolverTipoPlanId();

      const fmt = f => { if (!f) return null; const [y, m, d] = f.split('-'); return `${d}/${m}/${y}`; };
      const fmtDate = f => { if (!f) return null; const [y, m, d] = f.split('-'); return `${d}/${m}/${y}`; };

      // Sufijo nombre_compuesto (solo si no tiene ya el sufijo)
      let nombreCompuesto = this.programa.nombre_compuesto;
      if (!nombreCompuesto.endsWith(')')) {
        const uni = this.universidadsel?.id ? `U${this.universidadsel.id}` : 'U';
        nombreCompuesto += ` (V${this.programa.version} G${this.programa.grupo} ${this.programa.gestion} S${this.programa.sede_id} ${uni})`;
      }

      // Separar módulos nuevos vs existentes
      const addmodulos = [], modmodulos = [];
      this.programa.programa_modulo.forEach(m => {
        const esNuevo = !m.programa_modulo_id || m.programa_modulo_id < 0;
        if (esNuevo) {
          const mod = {
            modulo_id: m.modulo_id,
            numero: Number(m.numero),
            tipo_calificacion: m.tipo_calificacion, 
            modulo_programa_universidad_id: m.modulo_programa_universidad_id,
          };
          if (m.fecha_inicio) mod.fecha_inicio = fmtDate(m.fecha_inicio);
          if (m.fecha_fin) mod.fecha_fin = fmtDate(m.fecha_fin);
          addmodulos.push(mod);
        } else {
          const mod = {
            programa_modulo_id: m.programa_modulo_id,
            modulo_id: m.modulo_id,
            numero: Number(m.numero),
            course_id: 0,
            tipo_calificacion: m.tipo_calificacion,
          };
          if (m.fecha_inicio) mod.fecha_inicio = fmtDate(m.fecha_inicio);
          if (m.fecha_fin) mod.fecha_fin = fmtDate(m.fecha_fin);
          modmodulos.push(mod);
        }
      });

      // Separar planes nuevos vs existentes
      const newplanes = [], oldplanes = [];
      for (const p of this.programa.planes) {
        if (!p.plan_cobro_programa_id) {
          for (const c of p.cobros) {
            if (c.monto === null || c.monto === undefined || c.monto < 0) {
              this.msg = `Monto inválido en plan "${p.nombre}"`;
              return;
            }
            if (c.xmax_cuotas && c.cuotas > c.xmax_cuotas) {
              this.msg = `Cuotas (${c.cuotas}) superan el máximo (${c.xmax_cuotas}) en "${p.nombre}"`;
              return;
            }
          }
          const np = {
            tipo_plan_id: p.tipo_plan_id || null,
            nombre: p.nombre,
            aprobado: p.aprobado,
            estado: p.estado,
            cobros: p.cobros.map(c => ({
              concepto_pago_id: c.concepto_pago_id,
              nombre_concepto: c.nombre_concepto,
              monto: c.monto,
              cuotas: c.cuotas,
            })),
          };
          newplanes.push(np);
        } else {
          const op = {
            plan_cobro_programa_id: p.plan_cobro_programa_id,
            nombre: p.nombre,
            tipo_plan_id: p.tipo_plan_id || null,
            tipo_lista_precio_id: p.tipo_lista_precio_id || null,
            aprobado: p.aprobado,
            estado: p.estado,
            fecha_registro: p.fecha_registro || null,
            cobros: p.cobros.map(c => ({
              nombre: c.nombre,
              facturable: c.facturable,
              monto: String(c.monto),
              cuotas: c.cuotas,
              concepto_id: c.concepto_id,
              concepto_pago_id: c.concepto_pago_id,
            })),
          };
          oldplanes.push(op);
        }
      }

      let obj;
      if (this.modoEdicion) {
        // Payload para PUT (editar programa existente)
        obj = {
          programa_id: this.programa.programa_id,
          posgrado_id: this.programa.posgrado_id,
          version: this.programa.version,
          grupo: this.programa.grupo,
          gestion: this.programa.gestion,
          sede_id: this.programa.sede_id,
          modalidad: this.programa.modalidad,
          nombre_compuesto: nombreCompuesto,
          nota_aprobacion: this.programa.nota_aprobacion,
          portada: this.programa.portada,
          fecha_matricula: fmt(this.programa.fecha_matricula),
          fecha_inicio: fmt(this.programa.fecha_inicio),
          fecha_fin: this.programa.fecha_fin ? fmt(this.programa.fecha_fin) : null,
          universidad_id: this.universidadsel?.id || null,
          categoria_id: 0,
          coordinador: this.coordinadorsel.idusuario?.id
            ? { coordinador_id: this.coordinadorsel.idusuario.id }
            : null,
          // Campos del servidor (echo-back)
          ...this.xprogramaraw,
          // Módulos y planes
          modulos: addmodulos,
          modificar_modulos: modmodulos,
          planes: newplanes,
          modificar_planes: oldplanes,
        };
      } else {
        // Payload para POST (nuevo programa)
        obj = {
          nombre_compuesto: nombreCompuesto,
          posgrado_id: this.programa.posgrado_id,
          xcategoria_id: this.programa.xcategoria_id,
          nota_aprobacion: this.programa.nota_aprobacion,
          version: this.programa.version,
          grupo: this.programa.grupo,
          gestion: this.programa.gestion,
          sede_id: this.programa.sede_id,
          modalidad: this.programa.modalidad,
          portada: this.programa.portada,
          fecha_matricula: fmt(this.programa.fecha_matricula),
          fecha_inicio: fmt(this.programa.fecha_inicio),
          fecha_fin: this.programa.fecha_fin ? fmt(this.programa.fecha_fin) : null,
          programa_universidad_id: parseInt(this.$route.query.programa_universidad_id),
          tipo_programa: this.$route.query.modalidad,
          modulos: addmodulos,
          modificar_modulos: modmodulos,
          planes: newplanes,
          modificar_planes: oldplanes,
        };
        if (this.coordinadorsel.idusuario?.id)
          obj.coordinador = { coordinador_id: this.coordinadorsel.idusuario.id };
        if (this.responsablesel.idusuario?.id)
          obj.responsable = { responsable_id: this.responsablesel.idusuario.id };
        if (this.universidadsel?.id)
          obj.universidad_id = this.universidadsel.id;
      }

      // Armar resumen para confirmación
      const resumen = {
        esEdicion: this.modoEdicion,
        programa_id: this.programa.programa_id,
        nombre_compuesto: obj.nombre_compuesto,
        sedeNombre: this.sedeNombre,
        modalidad: obj.modalidad,
        gestion: obj.gestion,
        version: obj.version,
        grupo: obj.grupo,
        nota_aprobacion: obj.nota_aprobacion,
        fecha_matricula: obj.fecha_matricula,
        fecha_inicio: obj.fecha_inicio,
        fecha_fin: obj.fecha_fin || null,
        coordinador: this.coordinadorsel.idusuario?.nombres || this.coordinadorsel.idusuario?.nombres_completos || '',
        responsable: this.responsablesel.idusuario?.nombres || this.responsablesel.idusuario?.nombres_completos || '',
        sucursal: this.sucursalTexto || null,
        universidad: this.universidadsel?.id ? `(${this.universidadsel.abreviatura}) ${this.universidadsel.nombre}` : '',
        modulos: this.programa.programa_modulo.map(m => ({
          numero: m.numero,
          nombre: m.xmodulo ? m.xmodulo.nombre : '—',
          tipo_calificacion: m.tipo_calificacion,
          fecha_inicio: m.fecha_inicio ? fmt(m.fecha_inicio) : '',
          fecha_fin: m.fecha_fin ? fmt(m.fecha_fin) : '',
        })),
        planes: this.programa.planes.map(p => ({
          nombre: p.nombre,
          xauto: p.xauto,
          estado: p.estado,
          cobros: p.cobros.map(c => ({
            nombre_concepto: c.nombre_concepto,
            monto: c.monto,
            cuotas: c.cuotas,
          })),
        })),
      };

      const confirmar = await this.$refs.refConfirmarGuardar.openmodal(resumen);
      if (!confirmar) return;

      const metodo = this.modoEdicion ? 'PUT' : 'POST';
      const url = this.modoEdicion
        ? `${process.env.VUE_APP_API_REST}/esam/programa`
        : `${process.env.VUE_APP_API_REST}/esam/programa`;

      this.loading = true;
      fetch(url, { method: metodo, headers: getheadersrest(), body: JSON.stringify(obj) })
        .then(r => r.json())
        .then(async (result) => {
          this.msg = ''
          this.loading = false;

          if (result.programa_id) {
            this.show_btn_save = false;
            const rr = await this.auto_cambiar_fase(result.programa_id);
            const t = `Programa registrado exitosamente, ID: ${result.programa_id} ${rr}`;
            this.msg_reg = t;
            this.$root.$notify.show(t, { color: '#0c9689', x: 'right', timeout: 15000 });

          } else if(result.data == 'Programa modificado correctamente'){
            this.show_btn_save = false;
            this.$root.$notify.show(result.data, { color: '#0c9689', x: 'right', timeout: 15000 });

          } else {
            this.msg = result.error || result.data || 'Error al guardar';
          }
        })
        .catch(() => { this.loading = false; this.msg = 'Error de conexión'; });
    },

    async auto_cambiar_fase(programa_id){
      window.console.log('programa_id',programa_id);
      return 'programa ESAM creado en el portal.'
      
      // ya no se pone en inscripciones
      /* window.console.log('auto_cambiar_fase', programa_id);
      const sql = gql`mutation{ aprobarPrograma(input:{id:${programa_id},fase:0}){ok,errors{message}} }`;
      const res = await this.$apollo.mutate({ mutation: sql }).then(({data}) => data).catch(e=>e);
      window.console.log('auto_cambiar_faseress', res)
      if(res && res.aprobarPrograma){
        const r = res.aprobarPrograma;
        if(r.ok) return 'programa ESAM en fase de inscripciones.'
        else return 'DNA debe hacer el cambio de fase.'
      }
      return ':(' */
    },
  },

  beforeDestroy() {
    this.$store.state.show_rol_select = true;
  },

  async mounted() {
    this.msg_reg = ''
    this.show_btn_save = true;
    this.$store.state.show_rol_select = false;
    await Promise.all([this.getSedes(), this.getConveniosUniversidades()]);

    const editId = this.$route.query.edit;
    if (editId) {
      await this.cargarProgramaParaEditar(editId);
      return;
    }

    // Modo creación: requiere programa_universidad_id y modalidad
    if (!this.$route.query.programa_universidad_id || !this.$route.query.modalidad || !this.$route.query.fechaic) {
      this.$dialog.alert({ title: 'ALERTA:', body: 'Faltan parámetros requeridos: programa_universidad_id, modalidad y fechaic.' });
      return;
    }

    const version = parseInt(this.$route.query.version, 10);
    const grupo = parseInt(this.$route.query.grupo, 10);

    this.programa.fecha_matricula = this.$route.query.fechaic;
    this.programa.modalidad = 'S';
    this.programa.version = Number.isNaN(version) ? 0 : version;
    this.programa.grupo = Number.isNaN(grupo) ? 0 : grupo;

    const xpostgrado = window.sessionStorage.getItem('xpostgradorest');
    if (!xpostgrado) {
      this.$dialog.alert({ title: 'ALERTA:', body: 'No se pudo obtener el identificador del programa.' });
      return;
    }

    const post = JSON.parse(xpostgrado);
    this.xposgradin = post;
    this.programa.nombre_compuesto = post.nombre
      .replaceAll('Diplomado DIPLOMADO', 'DIPLOMADO')
      .replaceAll('Especialidad ESPECIALIDAD', 'ESPECIALIDAD')
      .replaceAll('Maestría Maestría', 'MAESTRÍA')
      .replaceAll('Maestria Maestria', 'MAESTRÍA');
    this.programa.posgrado_id = post.id;
    this.programa.xcategoria_id = post.categoria.id;
    this.programa.sede_id = this.$store.state.CARGO.sede.id;
    this.universidadsel = this.$store.state.convenio || null;

    await this.cargarModulosUniversidad();

    const programaUniversidadId = this.$route.query.programa_universidad_id;
    if (programaUniversidadId) {
      await this.cargarListaPrecios(programaUniversidadId);
    }
  },
};
</script>

<style src="./estilos_registro_programa.css"></style>
